import axios from 'axios';
import React, { Component } from 'react'
import * as BiIcons from 'react-icons/bi';
import { APIURL } from '../../hoc/AxiosSetting/axios';
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance';
export default class viewAccess extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             orgCode : props.match.params.orgcode,
             clientAccesData :{}
        }
    }
    handleClick=()=>{
        window.location.href="/admin/access"
    }

     componentDidMount(){
        axios.get(APIURL + '/api/clientaccess/get/clientaccessdetailsbyorgcode/' + this.state.orgCode)
        .then(res => {
            if(res.data.errorCode === 0){
                this.setState({clientAccesData : res.data.response})
            }
            else{
                     ToastInstance('Error','Data Not Found')
                }
        })

     }
    render() {
        return (
            <div>
                <div classname="content-wrapper">
                    <section classname="content">
                        <div classname="container-fluid">
                            <div classname="row" >
                             <div className="col-lg-12 col-lg-offset-1">
                                    <div class="card-body table-responsive">
                                        <table className="table table-bordered" >
                                            <thead className="table-primary">
                                                <tr>
                                                    <th scope="col" className="text-center" >#</th>
                                                    <th scope="col" className="text-center">Org Name </th>
                                                    <th scope="col" className="text-center">Org Code</th>
                                                    <th scope="col" className="text-center">Company Name</th>
                                                    <th scope="col" className="text-center">Type Of Org</th>
                                                    <th scope="col" className="text-center">Manager</th>
                                                    <th scope="col" className="text-center">Lead Auditor</th>
                                                    <th scope="col" className="text-center">Asst Auditor</th>
                                                    <th scope="col" className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <td className="text-center" >#</td>
                                                <td className="text-center">Org Name </td>
                                                <td className="text-center">Org Code</td>
                                                <td className="text-center">Company Name</td>
                                                <td className="text-center">Type Of Org</td>
                                                <td className="text-center">Manager</td>
                                                <td className="text-center">Lead Auditor</td>
                                                <td className="text-center">Asst Auditor</td>
                                                <td className="text-center" >
                                                    <span style={{ "marginRight": "6%", "cursor": "pointer" }} onClick={()=>this.handleClick()}><BiIcons.BiEdit /></span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                             </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}
